




























/**
 * 普通超会卡片视图组件
 * 用于提现页展示普通超级会员卡片
 * ui: https://www.figma.com/design/AdVYyTUKFJh8MzcmYqbHIv/
 * %E8%87%BB%E6%9C%89%E9%92%B1%E5%A4%A7%E4%BC%9A%E5%91%98?node-id=4243-24600&t=B34w9kx8KQPM6jZi-0
 */
import { defineComponent, PropType } from '@vue/composition-api';
import type { SuperCardSummaryBackType } from '@/api/rights/types';
import style from '../../index.module.scss';

export default defineComponent({
  name: 'SuperMemberCardView',
  props: {
    superMemberInfo: {
      type: Object as PropType<SuperCardSummaryBackType | null>,
      default: null,
    },
    check: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['goDetail'],
  setup(props, { emit }) {
    const goDetail = () => {
      emit('goDetail');
    };

    return {
      goDetail,
      style,
    };
  },
});
